<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">Update Hak Akses</section>
    <!-- Body -->
    <div class="w-full p-5">
      <vs-alert color="danger" title="Perhatian !" active="true">
        Pastikan <b>url</b> pada <b>vue router</b> yang ada di Digof-App sudah ditambahkan sebelumnya. Jika router belum ditambahkan
        maka sistem otomatis akan error. Mohon berhati-hati untuk melakukan input data ini.
      </vs-alert>
      <br/>
      <form>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Nama Akses"
              v-model="updateData.name"
              name="name"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{
              errors.first("name")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Tipe Akses"
              v-model="updateData.tipe_akses"
              name="tipe_akses"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('tipe_akses')">{{
              errors.first("tipe_akses")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="URL"
              v-model="updateData.url"
              name="url"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('url')">{{
              errors.first("url")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Icon"
              v-model="updateData.icon"
              name="icon"
              v-validate="'required|min:5'"
            />
            <span class="text-danger text-sm" v-show="errors.has('icon')">{{
              errors.first("icon")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <v-select :options="listParentAkses" v-model="selectedParentAkses" name="selectedParentAkses"/>
          </div>
        </div>
      </form>
    </div>

    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="handleOnSubmit"
        >
          Update Hak Akses Child
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="handleOnCancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import vSelect from "vue-select";
import {GET_ALL as ALL_AKSES} from '@/query/hak-akses';
import { UPDATE } from "@/query/hak-akses";

export default {
  components : {
    'v-select': vSelect
  },
  props : {
    hakAkses : {
      type : Object,
      required : true
    }
  },
  data() {
    return {
      dialog: {
        isActive: false,
        files: []
      },
      updateData: {
        name: '',
        tipe_akses: '',
        url: '',
        icon: '',
        parentakses_id: null,
        show: true
      },
      selectedParentAkses: {value : null, label : 'Tanpa Parent Akses'},
      listParentAkses: [{value : null, label : 'Tanpa Parent Akses'}],
    };
  },
  apollo : {
    listParentAkses : {
      query : ALL_AKSES,
      update : (data) => {
        let list = [{value : null, label : 'Tanpa Parent Akses'}];
        data.hakAkses.data.map(item => {
          list.push({ value: item.id, label: item.name });
        });
        return list;
      },
      variables(){
        return {
          perPage: 1000,
          where: {column: "PARENTAKSES_ID", operator: "IS_NULL"}
        }
      },
      fetchPolicy: "cache-and-network",
    },
  },
  watch: {
    hakAkses:{
      handler(){
        this.assignData();
      }
    },
    selectedParentAkses:{
      handler(){
        this.updateData.parentakses_id = this.selectedParentAkses.value;
      }
    }
  },
  methods: {
    assignData(){
      Object.keys(this.updateData).map(item => {
        if(this.hakAkses.hasOwnProperty(item)){
          this.updateData[item] = this.hakAkses[item];
        }
      });

      if(this.hakAkses.parent != null){
        this.selectedParentAkses.value = this.hakAkses.parent.id;
        this.selectedParentAkses.label = this.hakAkses.parent.name;
      }
    },
    async handleOnSubmit(){
      await this.$validator.validateAll().then(result => {
        if (result) {
          this.$apollo.mutate({
            mutation: UPDATE,
            variables: {
              id: this.hakAkses.id,
              input: {
                ...this.updateData
              }
            }
          })
          .then(() => {
            this.$vs.notify({
              title: 'Berhasil melakukan update hak akses.',
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position : "top-right"
            });
            window.setTimeout(() => {
              this.toggleActive(false);
              this.submitCallback();
              this.$emit("submitCallback", true);
            },700);
          })
          .catch((error) => {
            console.log(error);
          })
        }
        else{
          this.$vs.notify({
            title: "Silahkan lengkapi form terlebih dahulu !",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        }
      });
    },
    handleOnCancel() {
      this.toggleActive(false);
    },
    submitCallback() {
      this.$emit("submitCallback", true);
    },
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
    },
  }
};
</script>
